import LoadDetails from './styled';

export default LoadDetails;
